module.exports = __webpack_public_path__ + "static/media/slide-levels.6b6f7021.svg";